import React, { FC, useContext } from 'react'
import { ChatBox } from '../box/ChatBox'
import styled from '@emotion/styled'
import { ChatMobileFooter } from './ChatMobileFooter'
import { ChatMobilePreview } from './preview/ChatMobilePreview'
import { ChatContext } from '../context/ChatContext'
import { ChatMobileContextProvider } from './ChatMobileContext'
import { PreviewEditsContext } from '../../features/preview-edits/model/PreviewEditsContext'

const Container = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing.sm,
  height: '100%',
}))

export const ChatMobile: FC = () => {
  const { preview } = useContext(ChatContext)
  const { isChatLocked } = useContext(PreviewEditsContext)

  return (
    <ChatMobileContextProvider>
      <Container>
        {preview && <ChatMobilePreview preview={preview} />}

        {!isChatLocked && <ChatBox />}
        <ChatMobileFooter />
      </Container>
    </ChatMobileContextProvider>
  )
}
